import * as React from 'react'
import moment from 'moment'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { Empty, Table } from 'antd'
import { Routes } from '../../constants/Routes'

interface Props {
  companyId: number
  inventoryLogs: IInventoryLog[]
}

export class TransferInventoryLogTable extends React.Component<Props> {
  render() {
    const { companyId, inventoryLogs } = this.props
    const responsiveNumberColumnWidth = { width: 70 }

    const columns = [
      {
        title: 'Date',
        key: 'date',
        width: 150,
        render: (log: IInventoryLog) => (
          <span>
            <span>
              {moment(log.createDate).format('MMM D YYYY')}{' '}
              {moment(log.createDate).format('hh:mm a')}
            </span>
          </span>
        ),
      },
      {
        title: 'Product',
        key: 'product',
        render: (log: IInventoryLog) => (
          <a
            href={Routes.EDIT_PRODUCT(companyId, log.parentProductId || log.productId)}
            target='_blank'
            rel='noreferrer'
          >
            {log.productName}
          </a>
        ),
        width: 200,
      },
      {
        title: 'SKU',
        key: 'productSku',
        render: (log: IInventoryLog) => log.productSku,
        width: 100,
      },
      {
        title: 'Employee',
        key: 'employee',
        render: (log: IInventoryLog) => log.userName,
        width: 92,
      },
      {
        title: 'Location',
        key: 'location',
        width: 110,
        render: (log: IInventoryLog) => log.entityName,
      },
      {
        title: 'Opening',
        key: 'start',
        render: (log: IInventoryLog) => log.previousValue,
        align: 'right' as const,
        ...responsiveNumberColumnWidth,
      },
      {
        title: 'Change',
        key: 'change',
        render: (log: IInventoryLog) => (
          <b
            className={
              log.updateValue > 0
                ? 'text-success'
                : log.updateValue < 0
                ? 'text-danger'
                : 'text-muted'
            }
          >
            {log.updateValue > 0 ? '+' : ''}
            {log.updateValue}
          </b>
        ),
        align: 'right' as const,
        ...responsiveNumberColumnWidth,
      },
      {
        title: 'Closing',
        key: 'end',
        render: (log: IInventoryLog) => log.newValue,
        align: 'right' as const,
        ...responsiveNumberColumnWidth,
      },
    ]

    return (
      <Table
        className='mt-2 mb-2 background-white'
        pagination={false}
        size='middle'
        dataSource={inventoryLogs}
        columns={columns}
        rowKey={(logs) => logs.id.toString()}
        scroll={{ x: '100%' }}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description={'No inventory changes'} />
          ),
        }}
      />
    )
  }
}
